export { IdTypes } from './private/types';
export type { IdType } from './private/types';
export { createFeatureScope } from './private/scope';
